import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { Button } from "primereact/button";
import React from "react";

interface ButtonGroupProps<T> {
	options: { title: string; data: T }[];
	value: T;
	onChange?: (data: T) => void;
	style?: React.CSSProperties;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
export const ButtonGroup = <T,>({ style, options, value, onChange }: ButtonGroupProps<T>): JSX.Element => (
	<div style={style}>
		{options.map((option, index) => {
			const isFirst = index === 0;
			const isLast = index === options.length - 1;
			let position: "left" | "center" | "right" = "center";
			if (isFirst) {
				position = "left";
			} else if (isLast) {
				position = "right";
			}
			return (
				<ButtonGroupItem
					key={option.title}
					onClick={() => onChange?.(option.data)}
					position={position}
					active={option.data === value}
					label={option.title}
				/>
			);
		})}
	</div>
);

const ButtonGroupItem = styled(Button)<{ position: "left" | "center" | "right"; active?: boolean }>`
	border-top-left-radius: ${({ position }) => (position === "left" ? "8px" : "0")};
	border-bottom-left-radius: ${({ position }) => (position === "left" ? "8px" : "0")};
	border-top-right-radius: ${({ position }) => (position === "right" ? "8px" : "0")};
	border-bottom-right-radius: ${({ position }) => (position === "right" ? "8px" : "0")};
	background-color: ${({ active }) => (active ? colors.primary10 : colors.transparent)};
	color: ${({ active }) => (active ? colors.primary : colors.black)};
	border-color: ${({ active }) => (active ? colors.primary : colors.primary10)};
	:hover {
		color: ${colors.primary} !important;
		background-color: ${colors.primary10} !important;
	}
`;
